import React, { useEffect } from "react";
import { Button } from "@material-ui/core";
import { Grid, Select, MenuItem, Input, FormControl, InputLabel } from "@material-ui/core";
import Widget from "../../components/Widget";
// import InputLabel from '@mui/material/InputLabel';
// import FormControl from '@mui/material/FormControl';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles, useTheme } from '@material-ui/core/styles';

// styles
import useStyles from "./styles";
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';

// components
import { Typography } from "../Wrappers";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
export default function PageTitle(props) {
  var classes = useStyles();
  const theme = useTheme();

  const [value, setValue] = React.useState(props?.tabSelection);

  const [age, setAge] = React.useState(props?.initialData);
  const click = () => {
    props.add_new(true);
  }
  // useEffect(()=>{
  //   setValue(props?.tabSelection)
  // },[])
  const handleChange = (event) => {
    setAge(event.target.value);
    props.selectValue(event.target.value);

  };
  const handleChange2 = (event, newValue) => {
    setValue(newValue);
    props.tabValue("", newValue);

  };
  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      'aria-controls': `full-width-tabpanel-${index}`,
    };
  }
  return (
    // <div className={classes.pageTitleContainer}>
    <Grid container spacing={4} md={12} sm={12} xs={12} style={{  display: "flex", "flex-direction": "row", justifyContent: "space-between" }}>

    <Grid item md={12} sm={12} xs={12}>
      {props?.title && (<div style={{ flex: (props.width) ? props.width[0] : '0.7' }}>
       
          <Typography variant="h3" weight={"bold"} color="#101828">
            {props.title}    {props.title2}
          </Typography>
          <Typography color="#475467">
            {props.subtitle}
          </Typography>
      
      
       
      </div>)}
    </Grid>
      
      {props?.data && (<Grid item md={6} sm={6} xs={6}>
        <FormControl variant="outlined" sx={{ m: 1 , overflow: "initial"}}  style={{ borderRadius: "12px",
          background: "#fff",backgroundColor: "#fff", maxWidth: "300px", flex: (props.width) ? props.width[1] : '0.5' }}>
          <InputLabel htmlFor={props?.dropDownName} id="demo-simple-select-standard-label">{props?.dropDownName}</InputLabel>
          <Select
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            value={age}
            onChange={handleChange}
            label={props?.dropDownName}
          >
            {props.data.map((algo) => (
              <MenuItem value={algo}>{algo}</MenuItem>
            ))}
          </Select>
        </FormControl></Grid>)
      }

   

      {props?.tabs2 && (
        <Grid item md={6} sm={6} xs={6}>
          <Tabs
            value={value}
            onChange={handleChange2}
            style={{ backgroundColor: "#fff", flex: (props.width) ? props.width[2] : '0.5', marginLeft: "20px",border:"1px solid #EAECF0",borderRadius:"12px",boxShadow:"0px 1px 2px 0px #1018280D",backgroundColor:"#fff" }}
            variant="fullWidth"
            indicatorColor="primary"
            textColor="primary"
            aria-label="full width tabs example"
          >
            {props.tabs2.map((algo, index) => (
              <Tab label={algo} {...a11yProps(index)} />

            ))}
            {/* <Tab label="Item One" {...a11yProps(0)} />
          <Tab label="Item Two" {...a11yProps(1)} />
          <Tab label="Item Three" {...a11yProps(2)} /> */}
          </Tabs>
          </Grid>
      )
      }
      

    </Grid>
  );
}
